import { render, staticRenderFns } from "./configureClient.vue?vue&type=template&id=18622a5a"
import script from "./configureClient.vue?vue&type=script&lang=js"
export * from "./configureClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports